export default __webpack_public_path__ + "static/woman-developer-thinking--mobile-572f9d05628e1474ccb0ceecc573abaa.webp";